export const build = import.meta.env.VITE_APP_BUILD;
export const meta_pixel_api_key = import.meta.env
  .VITE_APP_META_PIXEL_API_KEY as string;

export const common_assets_s3 =
  "https://apollo-common-assets.s3.eu-west-3.amazonaws.com/images";

export const image_placeholder_s3 = `${common_assets_s3}/image_placeholder.jpg`;
